(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5217],{

/***/ 299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


// `messages` carries the backend's own words when it explained the failure;
// without it the dialog keeps its original generic wording.
var FormErrorDialog = function(param) {
    var click = param.click, _messages = param.messages, messages = _messages === void 0 ? [] : _messages;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = "unset";
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: click,
            className: "fixed inset-0 z-10 flex items-center justify-center w-full h-full bg-black-default/10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center justify-between w-full h-full px-5 py-10 overflow-auto text-center text-white md:w-3/5 md:h-2/4 bg-blue",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "pt-32 text-2xl md:text-5xl mb-11 md:p-0",
                        children: messages.length > 0 ? "We could not send your request." : "An error occurred when sending your message."
                    }),
                    messages.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "mb-8 text-xl leading-8 md:text-2xl",
                        children: messages.map(function(message) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: message
                            }, message);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-8 text-xl leading-8 md:text-3xl",
                        children: "Please try again in a few minutes."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: click,
                        className: "w-48 px-12 py-2 text-lg font-medium text-white h-14 bg-orange",
                        children: "Try Again"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormErrorDialog);


/***/ }),

/***/ 1987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5506);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var FormSuccessDialog = function(param) {
    var toggleModal = param.toggleModal, userType = param.userType;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = "unset";
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: function() {
                return toggleModal(false);
            },
            className: "fixed inset-0 z-10 flex items-center justify-center w-full h-full bg-black-default/10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid w-full h-full grid-cols-1 px-5 py-10 overflow-auto text-center border-white border-solid md:w-3/5 md:h-2/4 border-1 bg-white-light text-blue",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function() {
                                return toggleModal(false);
                            },
                            className: "absolute top-5 right-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                className: "w-6 h-6",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col items-center justify-between w-full h-full md:p-0 pt-36",
                            children: userType === "individual" || userType === "broker" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "text-3xl md:text-5xl mb-11",
                                        children: "Thank you for your interest."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mb-12 text-xl leading-10",
                                        children: [
                                            "Evry is currently only available for employers. ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "We will let you know as soon as it is available for individuals."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "mailto:contact@evryhealth.com",
                                        onClick: function() {
                                            return toggleModal(false);
                                        },
                                        className: "inline-block px-6 py-2 text-lg font-medium bg-green text-white-light hover:bg-blue",
                                        children: "Tell your employer about Evry"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "text-3xl md:text-5xl mb-11",
                                        children: [
                                            "Thanks for",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "inline-block",
                                                children: "contacting us."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mb-12 text-xl leading-10 xl:whitespace-nowrap",
                                        children: "We will be in touch very soon."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "w-48 px-12 py-2 text-lg font-medium text-white bg-green",
                                        onClick: function() {
                                            return toggleModal(false);
                                        },
                                        children: "Close"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormSuccessDialog);


/***/ }),

/***/ 1427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5245);
/* harmony import */ var _RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1__);


var RadioInput = function(param) {
    var children = param.children, value = param.value, selectedValue = param.selectedValue, required = param.required, name = param.name, change = param.change;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "".concat((_RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1___default().label), " relative block px-2 mx-3.5 my-4 font-[sans-serif]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: "".concat((_RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1___default().input), " opacity-0 absolute pointer-events-none"),
                    type: "radio",
                    value: value,
                    required: required,
                    name: name,
                    checked: value == selectedValue,
                    onChange: change
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1___default().radioInput), " ").concat(value === selectedValue ? (_RadioInput_module_css__WEBPACK_IMPORTED_MODULE_1___default().is_checked) : "")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-darkGray text-base align-middle ml-2 font-[sans-serif]",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioInput);


/***/ }),

/***/ 4559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecaptchaModal; }
/* harmony export */ });
/* unused harmony export RecaptchaCheckbox */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function RecaptchaCheckboxInner(param) {
    var _siteKey = param.siteKey, siteKey = _siteKey === void 0 ? "6LcMXrYrAAAAAO_ST6vZ-pm1SnS4P0nWJX2qXsiA" : _siteKey, onVerify = param.onVerify, onExpired = param.onExpired, onError = param.onError, _theme = param.theme, theme = _theme === void 0 ? "light" : _theme, _size = param.size, size = _size === void 0 ? "normal" : _size, _widgetIdRef = param.widgetIdRef, widgetIdRef = _widgetIdRef === void 0 ? null : _widgetIdRef;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var internalWidgetId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var mounted = true;
        if (!siteKey) {
            onError && onError(new Error("reCAPTCHA site key not configured"));
            return;
        }
        var ensureScript = function() {
            return new Promise(function(resolve, reject) {
                if (window.grecaptcha && window.grecaptcha.render) return resolve();
                var existing = document.querySelector('script[src*="recaptcha/api.js"]');
                if (existing) {
                    existing.addEventListener("load", function() {
                        return resolve();
                    });
                    existing.addEventListener("error", function() {
                        return reject(new Error("recaptcha script failed to load"));
                    });
                    return;
                }
                var s = document.createElement("script");
                s.src = "https://www.google.com/recaptcha/api.js?render=explicit";
                s.async = true;
                s.defer = true;
                s.onload = function() {
                    return resolve();
                };
                s.onerror = function() {
                    return reject(new Error("recaptcha script failed to load"));
                };
                document.head.appendChild(s);
            });
        };
        ensureScript().then(function() {
            if (!mounted) return;
            if (!window.grecaptcha || !window.grecaptcha.render) {
                onError && onError(new Error("grecaptcha not available"));
                return;
            }
            try {
                var id = window.grecaptcha.render(containerRef.current, {
                    sitekey: siteKey,
                    theme: theme,
                    size: size,
                    callback: function(token) {
                        onVerify && onVerify(token);
                    },
                    "error-callback": function() {
                        onError && onError(new Error("reCAPTCHA checkbox verification failed"));
                    },
                    "expired-callback": function() {
                        onExpired && onExpired();
                    }
                });
                internalWidgetId.current = id;
                if (widgetIdRef && typeof widgetIdRef === "object") widgetIdRef.current = id;
            } catch (err) {
                onError && onError(err);
            }
        }).catch(function(err) {
            return onError && onError(err);
        });
        return function() {
            mounted = false;
            try {
                if (internalWidgetId.current != null && window.grecaptcha && window.grecaptcha.reset) {
                    window.grecaptcha.reset(internalWidgetId.current);
                }
            } catch (e) {}
        };
    }, [
        siteKey,
        onVerify,
        onExpired,
        onError,
        theme,
        size,
        widgetIdRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: containerRef
    });
}
function RecaptchaCheckbox(props) {
    return /*#__PURE__*/ _jsx(RecaptchaCheckboxInner, _object_spread({}, props));
}
function RecaptchaModal(param) {
    var _message = param.message, message = _message === void 0 ? "Please complete the verification to continue" : _message, onVerify = param.onVerify, onError = param.onError, onClose = param.onClose, siteKey = param.siteKey, theme = param.theme, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    background: "rgba(0,0,0,0.5)",
                    position: "absolute",
                    inset: 0
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    zIndex: 10000,
                    background: "#fff",
                    padding: 20,
                    borderRadius: 8,
                    minWidth: 320,
                    maxWidth: "90%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        style: {
                            marginBottom: 10
                        },
                        children: message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecaptchaCheckboxInner, {
                        siteKey: siteKey,
                        theme: theme,
                        size: size,
                        onVerify: function(token) {
                            return onVerify && onVerify(token);
                        },
                        onError: function() {
                            return onError && onError();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginTop: 8,
                            textAlign: "right"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "px-4 py-2 text-sm",
                            onClick: function() {
                                return onClose && onClose();
                            },
                            children: "Cancel"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _TextInput_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2426);
/* harmony import */ var _TextInput_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextInput_module_css__WEBPACK_IMPORTED_MODULE_3__);






var TextInput = function(_param) {
    var children = _param.children, required = _param.required, change = _param.change, disabled = _param.disabled, labelClasses = _param.labelClasses, value = _param.value, onBlurCustom = _param.onBlurCustom, onFocusCustom = _param.onFocusCustom, error = _param.error, prefix = _param.prefix, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "required",
        "change",
        "disabled",
        "labelClasses",
        "value",
        "onBlurCustom",
        "onFocusCustom",
        "error",
        "prefix"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), focusClass = ref[0], SetfocusClass = ref[1];
    var handleFocus = function(e) {
        SetfocusClass((_TextInput_module_css__WEBPACK_IMPORTED_MODULE_3___default().is_active));
        onFocusCustom && onFocusCustom(e);
    };
    var handleBlur = function(e) {
        SetfocusClass("");
        onBlurCustom && onBlurCustom(e);
    };
    var inputElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        onChange: change
    }, rest), {
        required: required,
        value: value,
        onFocus: handleFocus,
        onBlur: handleBlur,
        className: "".concat((_TextInput_module_css__WEBPACK_IMPORTED_MODULE_3___default().input), " bg-transparent border-none pt-6 pb-2 ").concat(prefix ? "flex-1 min-w-0 pl-1 pr-5" : "w-full px-5")
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "".concat((_TextInput_module_css__WEBPACK_IMPORTED_MODULE_3___default().label), "\n          relative\n          block\n          border-1 border-solid border-white\n          mx-1.5\n          my-2\n          px-2\n          pt-2\n          pb-4\n          md:mx-3.5 md:my-5\n          flex-grow\n          font-[sans-serif]\n          ").concat(labelClasses, "\n        "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "".concat((_TextInput_module_css__WEBPACK_IMPORTED_MODULE_3___default().span), "\n            absolute\n            text-darkGray\n            top-2\n            md:top-4\n            text-base\n            transition-transform\n            ").concat(prefix ? "left-8 md:left-11" : "left-4 md:left-7", "\n            ").concat(value && value.length > 0 ? "hidden" : "", "\n            ").concat(focusClass, "\n          "),
                    children: [
                        children,
                        required && " *"
                    ]
                }),
                prefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-baseline",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "aria-hidden": "true",
                            className: "pt-6 pb-2 pl-5 select-none pointer-events-none",
                            children: prefix
                        }),
                        inputElement
                    ]
                }) : inputElement,
                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-1 text-xs text-red pt-2",
                    children: error
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextInput);


/***/ }),

/***/ 3487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3686);
/* harmony import */ var _TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3__);






var TextInputArea = function(_param) {
    var children = _param.children, required = _param.required, height = _param.height, change = _param.change, disabled = _param.disabled, labelClasses = _param.labelClasses, value = _param.value, error = _param.error, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "required",
        "height",
        "change",
        "disabled",
        "labelClasses",
        "value",
        "error"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), focusClass = ref[0], SetfocusClass = ref[1];
    var handleFocus = function(e) {
        SetfocusClass((_TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3___default().is_active));
    };
    var handleBlur = function(e) {
        SetfocusClass("");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "".concat((_TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3___default().label), " relative block border-1 border-solid border-white px-7 pt-9 mx-1.5 my-2 md:mx-3.5 md:my-5 flex-grow font-[sans-serif] ").concat(labelClasses, " ").concat(error ? "border-red" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "absolute text-darkGray top-4 left-7 text-base transition-transform ".concat(focusClass, " ").concat(value.length > 0 ? "hidden" : ""),
                    children: [
                        children,
                        required && " *"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    onChange: change,
                    disabled: disabled,
                    required: required,
                    value: value
                }, rest), {
                    style: {
                        height: height
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    className: " ".concat((_TextInputArea_module_css__WEBPACK_IMPORTED_MODULE_3___default().textarea), " bg-transparent border-none w-full resize-none")
                })),
                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "absolute bottom-2 left-7 text-red text-sm",
                    children: error
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextInputArea);


/***/ }),

/***/ 3575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getRecaptchaV3Token; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);


var recaptchaReady = false;
function waitForGrecaptchaReady() {
    return _waitForGrecaptchaReady.apply(this, arguments);
}
function _waitForGrecaptchaReady() {
    _waitForGrecaptchaReady = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var timeoutMs, siteKey;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            timeoutMs = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 30000;
            if (false) {}
            siteKey = "6LcH66wrAAAAAEW3rb_ohWMciDcO_dxeskFi3cj5";
            if (!siteKey) throw new Error("recaptcha: NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3 is not set");
            if (recaptchaReady) return [
                2
            ];
            return [
                2,
                new Promise(function(resolve, reject) {
                    // wait for grecaptcha.ready to become available
                    var overall = setTimeout(function() {
                        var msg = "reCAPTCHA not available; ensure the script is included: https://www.google.com/recaptcha/api.js?render=SITE_KEY";
                        console.error("recaptcha:", msg);
                        reject(new Error(msg));
                    }, timeoutMs);
                    var check = function() {
                        if (window.grecaptcha && typeof window.grecaptcha.ready === "function") {
                            try {
                                window.grecaptcha.ready(function() {
                                    clearTimeout(overall);
                                    recaptchaReady = true;
                                    resolve();
                                });
                            } catch (e) {
                                clearTimeout(overall);
                                console.error("recaptcha: error during grecaptcha.ready", e);
                                reject(e);
                            }
                        } else {
                            setTimeout(check, 100);
                        }
                    };
                    check();
                })
            ];
        });
    });
    return _waitForGrecaptchaReady.apply(this, arguments);
}
function withTimeout(promise) {
    var timeoutMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30000;
    return new Promise(function(resolve, reject) {
        var t = setTimeout(function() {
            return reject(new Error("reCAPTCHA process timeout"));
        }, timeoutMs);
        promise.then(function(r) {
            clearTimeout(t);
            resolve(r);
        }).catch(function(err) {
            clearTimeout(t);
            reject(err);
        });
    });
}
function getRecaptchaV3Token() {
    return _getRecaptchaV3Token.apply(this, arguments);
}
function _getRecaptchaV3Token() {
    _getRecaptchaV3Token = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var action, siteKey;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    action = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "submit";
                    return [
                        4,
                        waitForGrecaptchaReady()
                    ];
                case 1:
                    _state.sent();
                    siteKey = "6LcH66wrAAAAAEW3rb_ohWMciDcO_dxeskFi3cj5";
                    return [
                        2,
                        withTimeout(new Promise(function(resolve, reject) {
                            try {
                                var exec = window.grecaptcha.execute(siteKey, {
                                    action: action
                                });
                                if (exec && typeof exec.then === "function") {
                                    exec.then(function(token) {
                                        return resolve(token);
                                    }).catch(function(err) {
                                        console.error("recaptcha: grecaptcha.execute promise rejected", err);
                                        reject(err);
                                    });
                                } else {
                                    var _$err = new Error("reCAPTCHA v3 execute is not returning a promise");
                                    console.error("recaptcha:", _$err);
                                    reject(_$err);
                                }
                            } catch (err) {
                                console.error("recaptcha: exception while calling grecaptcha.execute", err);
                                reject(err);
                            }
                        }))
                    ];
            }
        });
    });
    return _getRecaptchaV3Token.apply(this, arguments);
}


/***/ }),

/***/ 5245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioInput":"RadioInput_radioInput___tJH1","is_checked":"RadioInput_is_checked__2Z57D","label":"RadioInput_label__yiS__","input":"RadioInput_input__jWrTp"};

/***/ }),

/***/ 2426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__iTAid","input":"TextInput_input__sd6Bn","span":"TextInput_span__MstHr","is_active":"TextInput_is_active__s3oQe"};

/***/ }),

/***/ 3686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInputArea_label__OjgBG","is_active":"TextInputArea_is_active__k9Tnb","textarea":"TextInputArea_textarea__WmRxW"};

/***/ })

}]);